import { jsonLdHtml } from "@/lib/help-center-seo";
import type { ReactElement } from "react";

/**
 * Renders a schema.org JSON-LD block as a server-side `<script>` so it ships in
 * the initial HTML for crawlers. `data` is escaped against `</script>` breakout.
 */
export function HelpJsonLd({ data }: { readonly data: unknown }): ReactElement {
  return (
    <script
      type="application/ld+json"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD is safe serialized JSON
      dangerouslySetInnerHTML={{ __html: jsonLdHtml(data) }}
    />
  );
}
